<app-tab-layout [loading]="loading()" [error]="error">
  @if(initialized()) {
  <app-api-table
    [endpoint]="'/visits/tables/sales-performance'"
    [name]="'Sales Performance'"
    [chartColumn]="'Country'"
    [defaultSort]="{ 'Visits': 'desc' }"
  ></app-api-table>
  }
</app-tab-layout>
